import { css } from '@styled-system/css';
import { SystemProperties } from '@styled-system/types';
import type { ReactNode } from 'react';

import { Logo } from './Logo';

interface MessageProps {
  children: ReactNode;
  type?: 'info' | 'error';
  bordered?: boolean;
  underline?: boolean;
  className?: string;
  textColor?: SystemProperties['color'];
}

export const Message = ({
  children,
  type = 'info',
  bordered = false,
  underline = false,
  className,
  textColor,
}: MessageProps) => {
  const messageStyles = css({
    display: 'flex',
    alignItems: 'center',
    gap: 'xs', // 5px gap entre icône et texte

    // Border conditionnelle
    ...(bordered && {
      px: 'sm', // 10px padding horizontal
      p: '0.81rem',
      border: '0.75px solid',
      borderColor: 'border.default', // #1e1f24
      rounded: 'sm', // 6px border radius
    }),

    bg: 'transparent',

    // Couleurs selon le type
    color: textColor ?? (type === 'error' ? 'accent.red' : 'font.secondary'),

    // Typography du design
    fontSize: '2xs', // 9px
    fontWeight: 'medium', // Manrope Medium
    fontFamily: 'sans',
    lineHeight: '1.5',
  });

  const iconStyles = css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    w: '0.875rem',
    h: '0.875rem',
    flexShrink: 0,
  });

  return (
    <div className={`${messageStyles} ${className || ''}`}>
      <Logo
        className={iconStyles}
        variant={type === 'error' ? 'error' : 'info'}
        color={type === 'error' ? 'accent.red' : 'accent.primary'}
      />
      <div className={underline ? css({ textDecoration: 'underline' }) : ''}>{children}</div>
    </div>
  );
};
